import { FunctionComponent } from 'react';

import { Tag } from '../../../../atoms/Tag';
import { TAG_VARIANT } from '../../../../atoms/Tag/Tag.types';
import { SafeFormattedMessageWithoutSpread } from '../../../../formatters';
import messages from '../messages';

const FiltersPercentageTag: FunctionComponent<{
  min?: number;
  max?: number;
  defaultMin?: number;
  defaultMax?: number;
  dataTestId?: string;
}> = ({ min, max, defaultMin, defaultMax, dataTestId }) => {
  return (
    <Tag variant={TAG_VARIANT.PRIMARY} withoutMargin dataTestId={dataTestId}>
      {min !== undefined &&
        max !== undefined &&
        (min !== defaultMin || max !== defaultMax) &&
        `[${min}% - ${max}%]`}
      {min !== undefined && max === undefined && <span>{`> ${min}%`}</span>}
      {min === undefined && max !== undefined && <span>{`< ${max}%`}</span>}
      {((min === undefined && max === undefined) ||
        (min === defaultMin && max === defaultMax)) && (
        <SafeFormattedMessageWithoutSpread message={messages.allSelected} />
      )}
    </Tag>
  );
};

FiltersPercentageTag.displayName = 'FiltersPercentageTag';
export default FiltersPercentageTag;
